import request from "@/utils/request/index";

export enum Api {
  FETCH_NOTICE = "/systemMessage",
  CHANGE_NOTICE_STATUS = "/systemMessage/read",
}
// 获取消息列表
export const fetchNoticeList = (data?: any, config?: axiosConfig) =>
  request.get(Api.FETCH_NOTICE, data, config);

// 消息已读
export const readNotice = (data?: any) =>
  request.post(Api.CHANGE_NOTICE_STATUS, data);
